var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12590",
    "data-name": "Group 12590",
    transform: "translate(-2 -1.533)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_465",
    "data-name": "Ellipse 465",
    cx: 15,
    cy: 22.5,
    rx: 15,
    ry: 22.5,
    transform: "translate(10 2.533)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5142",
    "data-name": "Path 5142",
    d: "M47.533,24.935a22.206,22.206,0,0,1-7.282,16.47S32.689,36.6,25.267,36.6s-14.991,4.8-14.991,4.8a22.266,22.266,0,0,1-.049-32.884s7.617,4.756,15.039,4.756S40.282,8.493,40.282,8.493a22.206,22.206,0,0,1,7.251,16.442Z",
    transform: "translate(0 0.331)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_466",
    "data-name": "Ellipse 466",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(3 2.533)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5143",
    "data-name": "Path 5143",
    d: "M25.267,3V47.533M3,25.267H47.533",
    transform: "translate(0)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.a3dec18edf7bcab0756df19ec36b6a9f.svg";
export { ForwardRef as ReactComponent };